import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Card,
  Typography,
  CardContent,
  Divider,
  List,
  ListItemIcon,
  ListItemText,
  ListItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  useMediaQuery,
  Avatar,
  CardHeader,
  Tooltip,
} from "@mui/material";
import {
  useGetAllDhashboardFristQuery,
  useGetPositionQuery,
  useGetMissingPunchOutQuery,
  useGetTeamQuery,
  useGetPunchDashboardQuery,
  useGetOutOfLocationQuery,
} from "../../Api/attoDeskApi";
import {
  IPosition,
  ITeam,
  IPunchEmpRecord,
  historyPuncRecord,
} from "../../Api/Interface/api.interface";
import useDebounce from "../../Components/SearchDebonce/useDebounce";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../theme/appStyles";
import Pagination from "../../Components/Pagination";
import dayjs, { Dayjs } from "dayjs";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShieldIcon from "@mui/icons-material/Shield";
import GroupIcon from "@mui/icons-material/Group";
import EventIcon from "@mui/icons-material/EventNote";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { Link } from "react-router-dom";
import Badge from "@mui/material/Badge";
import { CiEdit } from "react-icons/ci";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import { GiReceiveMoney } from "react-icons/gi";
import { FaUserClock } from "react-icons/fa";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PayrollTrendChart from "./Component/payroll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Timelinechart from "./Component/timelinechart";
import PayrollBarChart from "./Component/payrollBar";
import PayrollPieChart from "./Component/payrollpieChart";
import Groups2Icon from "@mui/icons-material/Groups2";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import useIsMobile from "../../Core/hook/useIsMobile";
import { BsDot } from "react-icons/bs";

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedCilent, setSelectedClient] = useState<string | "">("");
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { data, isLoading, isError, refetch } = useGetMissingPunchOutQuery();

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const { data: positionData, isLoading: positionLoading } =
    useGetPositionQuery({
      searchText: "",
    });

  const {
    data: dashboardData,
    isLoading: dashboardIsLoading,
    isError: dashboardIsError,
  } = useGetPunchDashboardQuery();

  const {
    data: outOfLocationData,
    isLoading: outOfLocationIsLoadig,
    isError: outOfLocationIsError,
    refetch: outOfLocationRefetch,
  } = useGetOutOfLocationQuery({
    date: dayjs().format("YYYY-MM-DD"),
  });

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const positionList = useMemo(() => {
    return positionData?.data as IPosition[];
  }, [positionData?.data]);

  const postionMap = useMemo(() => {
    const map = new Map();
    positionList?.forEach((category) => {
      map.set(category.id, category.positionName);
    });
    return map;
  }, [positionList]);

  const outOfLocationRecords: historyPuncRecord[] = Array.isArray(
    outOfLocationData?.data
  )
    ? (outOfLocationData?.data as historyPuncRecord[])
    : [];

  const teamMap = useMemo(() => {
    const map = new Map<
      number,
      {
        name: string;
        image: string;
        hourlySalary: string;
        otHourlySalary: string;
        positionName: string | null;
      }
    >();

    teamList?.forEach((teamMember) => {
      const fullName = `${capitalizeFirstLetter(
        teamMember.teamFirstName || ""
      )} ${capitalizeFirstLetter(teamMember.teamLastName || "")}`.trim();
      const positionName = postionMap.get(teamMember.teamPositionId) || null;

      map.set(teamMember.id, {
        name: fullName,
        image: teamMember.teamImg,
        hourlySalary: teamMember.teamHourlySalary,
        otHourlySalary: teamMember.teamOtHourlySalary,
        positionName,
      });
    });

    return map;
  }, [teamList, postionMap]);

  const coursings: IPunchEmpRecord[] = Array.isArray(data?.data)
    ? (data?.data as IPunchEmpRecord[])
    : [];

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const { data: clientData, isLoading: clientIsLoading } =
    useGetAllDhashboardFristQuery({
      id: "",
    });

  const hasRecords =
    (outOfLocationRecords?.length ?? 0) > 0 ||
    (dashboardData?.data?.invalidPunchRecords?.length ?? 0) > 0;

  if (
    isLoading ||
    tenantIsLoading ||
    positionLoading ||
    clientIsLoading ||
    dashboardIsLoading
  ) {
    return (
      <Box p={isMobile ? 2 : 1}>
        <Grid container spacing={2}>
          {[...Array(4)].map((_, index) => (
            <Grid
              item
              md={12}
              sm={12}
              xs={6}
              lg={3}
              key={`top-skeleton-${index}`}
            >
              <Skeleton
                variant="rectangular"
                // height={200}
                height={isMobile ? 50 : 100}
                animation="wave"
                className={classes.dhashboardCardSkeleton}
              />
            </Grid>
          ))}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Skeleton
                      variant="rectangular"
                      // height={200}
                      height={isMobile ? 100 : 300}
                      animation="wave"
                      className={classes.dhashboardCardSkeleton}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
              <Grid item lg={6} md={12} sm={12} xs={12}>
                <Skeleton
                  variant="rectangular"
                  // height={200}
                  height={isMobile ? 100 : 300}
                  animation="wave"
                  className={classes.dhashboardCardSkeleton}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <div>
      <Grid container>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            // backgroundColor: "#d0ddd0",
            // background: `linear-gradient(to bottom, ${theme.palette.primary.main}, #fff)`,
            // background: `linear-gradient(to bottom,  ${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.cardAdd.thirdBgColor},${theme.palette.primary.main},  #fff)`,

            padding: isMobile ? 1 : 2,
            minHeight: "100vh",
            borderRadius: 3,
            // boxShadow: 3,
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <Groups2Icon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.dashboardfristCardButtonText1}
                        >
                          Staff
                        </Typography>
                        <Typography
                          className={classes.dashboardfristCardButtonText2}
                        >
                          {clientData?.data.employee_count ?? "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <GiReceiveMoney
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.dashboardfristCardButtonText1}
                        >
                          Payroll
                        </Typography>
                        <Typography
                          className={classes.dashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_payroll_record ?? "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <AssignmentIcon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.dashboardfristCardButtonText1}
                        >
                          Schedule
                        </Typography>
                        <Typography
                          className={classes.dashboardfristCardButtonText2}
                        >
                          {clientData?.data.totalCoveragePolicy ?? "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                  <Card className={classes.staffDhashboardSmallCardUpdate}>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Box className={classes.dashboardfristCardButton}>
                          <CheckCircleOutlineIcon
                            className={classes.dashboardfristCardButtonIcon}
                          />
                        </Box>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        className={classes.dashboardfristCardGrid}
                      >
                        <Typography
                          className={classes.dashboardfristCardButtonText1}
                        >
                          Clock In/Out
                        </Typography>
                        <Typography
                          className={classes.dashboardfristCardButtonText2}
                        >
                          {clientData?.data.total_punches ?? "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={hasRecords ? 6 : 12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card
                        className={classes.staffDhashboardSmallCardUpdateNonoe}
                        sx={{ minHeight: 200 }}
                      >
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography
                              className={classes.dashboardfristCardHeading}
                              sx={{ paddingTop: "24px", paddingLeft: "24px" }}
                            >
                              <span className={classes.requiedfield}>
                                Incomplete Punch Details
                              </span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TableContainer>
                              <Table className={classes.dashboardtable}>
                                <TableHead
                                  className={classes.dashboardtableHeaderRow}
                                >
                                  <TableRow>
                                    <TableCell
                                      className={classes.dashboardtablheader}
                                    >
                                      <strong>Name</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.dashboardtablheader}
                                    >
                                      <strong>Date</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.dashboardtablheader}
                                    >
                                      <strong>Punch In</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.dashboardtablheader}
                                    >
                                      <strong>Punch Out</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {isError || coursings.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {isError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    coursings
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map((row: IPunchEmpRecord, index) => {
                                        const customer = teamMap.get(row.empid);
                                        return (
                                          <TableRow
                                            key={row.id}
                                            className={classes.tableRowHover}
                                          >
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                            >
                                              <Link
                                                to={`/team-history/${row.empid}`}
                                                className={
                                                  classes.iconLinkPropNormal
                                                }
                                              >
                                                <Grid container spacing={1}>
                                                  {!isMobileRes && (
                                                    <Grid item>
                                                      {customer?.image ? (
                                                        <Avatar
                                                          alt="Img"
                                                          src={customer.image}
                                                          className={
                                                            classes.avatatImage30
                                                          }
                                                          sx={{
                                                            cursor: "pointer",
                                                          }}
                                                        />
                                                      ) : (
                                                        <Avatar
                                                          className={
                                                            classes.avatatImage30
                                                          }
                                                        >
                                                          {customer?.name ? (
                                                            `${
                                                              customer?.name ??
                                                              ""
                                                            }`
                                                              .trim()
                                                              .charAt(0)
                                                              .toUpperCase()
                                                          ) : (
                                                            <GroupIcon />
                                                          )}
                                                        </Avatar>
                                                      )}
                                                    </Grid>
                                                  )}
                                                  <Grid
                                                    item
                                                    textAlign={"left"}
                                                    alignContent={"center"}
                                                  >
                                                    <Typography
                                                      className={
                                                        classes.nameTableList
                                                      }
                                                    >
                                                      {customer
                                                        ? `${customer.name}`
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </Link>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              // sx={{ textAlign: "center" }}
                                            >
                                              <Typography
                                                sx={{
                                                  // /  color: "#1976d2",
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  // alignItems: "center",
                                                  gap: 1,
                                                }}
                                              >
                                                {dayjs(
                                                  row.punch_in_date
                                                ).isValid()
                                                  ? dayjs(
                                                      row.punch_in_date
                                                    ).format("MMM-DD, YYYY")
                                                  : " "}
                                              </Typography>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              // sx={{ textAlign: "center" }}
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                // justifyContent={"center"}
                                              >
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  sx={
                                                    {
                                                      // display: "flex",
                                                      // justifyContent: "center",
                                                    }
                                                  }
                                                >
                                                  <Box
                                                    className={
                                                      classes.editButtonStatusAvailable
                                                    }
                                                  >
                                                    {formatTime(
                                                      row.punch_in_time
                                                    ) || "Pending"}
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                            </TableCell>
                                            <TableCell
                                              scope="row"
                                              className={classes.tablCell}
                                              // sx={{ textAlign: "center" }}
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                // justifyContent={"center"}
                                              >
                                                <Grid
                                                  item
                                                  lg={12}
                                                  md={12}
                                                  sm={12}
                                                  xs={12}
                                                  // sx={{
                                                  //   display: "flex",
                                                  //   justifyContent: "center",
                                                  // }}
                                                >
                                                  <Tooltip
                                                    title={
                                                      <>
                                                        <Typography
                                                          variant="body2"
                                                          key={index}
                                                        >
                                                          <strong>
                                                            Missing punch-out.
                                                            Please update the
                                                            time.{" "}
                                                          </strong>
                                                        </Typography>
                                                      </>
                                                    }
                                                    sx={{ fontSize: "14px" }}
                                                  >
                                                    <Box
                                                      className={
                                                        classes.editButtonStatusWaiting
                                                      }
                                                      sx={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        navigate(
                                                          `/schedule/list?date=${dayjs(
                                                            row.punch_in_date
                                                          ).format(
                                                            "YYYY-MM-DD"
                                                          )}`
                                                        )
                                                      }
                                                    >
                                                      <BsDot
                                                        style={{
                                                          fontSize: 20,
                                                          // marginRight: "2px",
                                                        }}
                                                      />
                                                      {formatTime(
                                                        row.punch_out_time
                                                      ) || "Pending"}
                                                    </Box>
                                                  </Tooltip>
                                                </Grid>
                                              </Grid>
                                            </TableCell>
                                          </TableRow>
                                        );
                                      })
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid
                              spacing={5}
                              p={"18px"}
                              py={4}
                              justifyContent={"end"}
                              container
                              textAlign={"center"}
                              alignContent={"center"}
                              alignItems={"center"}
                            >
                              <Grid
                                sx={{
                                  textAlign: "end",
                                  justifyContent: "flex-end",
                                  alignItems: "flex-end",
                                  pt: "2px",
                                }}
                              >
                                <Pagination
                                  count={coursings.length}
                                  page={page}
                                  rowsPerPage={rowsPerPage}
                                  onPageChange={handleChangePage}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
                {hasRecords && (
                  <Grid item lg={hasRecords ? 6 : 12} md={12} sm={12} xs={12}>
                    <Card
                      className={classes.staffDhashboardSmallCardUpdate}
                      sx={{ minHeight: 200 }}
                    >
                      <Grid container spacing={2}>
                        {dashboardData?.data.invalidPunchRecords &&
                          dashboardData?.data.invalidPunchRecords?.length >
                            0 && (
                            <>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography
                                  className={classes.dashboardfristCardHeading}
                                >
                                  <span className={classes.requiedfield}>
                                    Please check punch in/out times — invalid
                                    record.
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {dashboardIsError ? (
                                  <Box textAlign="center" py={4}>
                                    <Typography color="error">
                                      Error fetching data
                                    </Typography>
                                  </Box>
                                ) : dashboardIsLoading ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    py={4}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : dashboardData?.data.invalidPunchRecords
                                    ?.length === 0 ? (
                                  <Box textAlign="center" py={4}>
                                    <Typography>No Record Avilable</Typography>
                                  </Box>
                                ) : (
                                  <List sx={{ width: "100%" }}>
                                    {dashboardData.data.invalidPunchRecords.map(
                                      (record) => (
                                        <Grid item xs={12} key={record.id}>
                                          <Link
                                            to={`/schedule/list?date=${dayjs(
                                              record.punch_in_date
                                            ).format("YYYY-MM-DD")}`}
                                            className={
                                              classes.iconLinkPropNormal
                                            }
                                          >
                                            <Card
                                              onClick={() =>
                                                navigate(
                                                  `/schedule/list?date=${dayjs(
                                                    record.punch_in_date
                                                  ).format("YYYY-MM-DD")}`
                                                )
                                              }
                                              elevation={0}
                                              sx={{
                                                background:
                                                  theme.palette.cardAdd.bgColor,
                                                display: "flex",
                                                alignItems: "center",
                                                p: 1,
                                                py: 1,
                                                cursor: "pointer",
                                                transition: "background 0.2s",
                                                "&:hover": {
                                                  backgroundColor:
                                                    theme.palette.action.hover,
                                                },
                                              }}
                                            >
                                              <Badge
                                                color="primary"
                                                sx={{
                                                  mr: 2,
                                                  "& .MuiBadge-badge": {
                                                    fontSize: "0.75rem",
                                                    minWidth: 20,
                                                    height: 20,
                                                    borderRadius: "50%",
                                                    backgroundColor: "green",
                                                    color: "#fff",
                                                  },
                                                }}
                                              >
                                                <Avatar
                                                  sx={{
                                                    bgcolor: "primary.main",
                                                  }}
                                                >
                                                  {teamMap.get(record.empid)
                                                    ?.name ? (
                                                    `${
                                                      teamMap.get(record.empid)
                                                        ?.name
                                                    }`
                                                      .trim()
                                                      .charAt(0)
                                                      .toUpperCase()
                                                  ) : (
                                                    <GroupIcon />
                                                  )}
                                                </Avatar>
                                              </Badge>

                                              <Box>
                                                <Typography>
                                                  {teamMap.get(record.empid)
                                                    ?.name || ""}
                                                </Typography>
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    fontSize: "0.875rem",
                                                    color: "#444",
                                                  }}
                                                >
                                                  Punch In:{" "}
                                                  <strong>
                                                    {dayjs(
                                                      record.punch_in_date
                                                    ).format("MMM DD")}{" "}
                                                    {formatTime(
                                                      record.punch_in_time
                                                    )}
                                                  </strong>{" "}
                                                  | Out:{" "}
                                                  <strong>
                                                    {dayjs(
                                                      record.punch_out_date
                                                    ).format("MMM DD")}{" "}
                                                    {formatTime(
                                                      record.punch_out_time
                                                    )}
                                                  </strong>
                                                </Typography>
                                              </Box>
                                            </Card>
                                          </Link>
                                        </Grid>
                                      )
                                    )}
                                  </List>
                                )}
                              </Grid>
                            </>
                          )}
                        {outOfLocationRecords &&
                          outOfLocationRecords?.length > 0 && (
                            <>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Typography
                                  className={classes.dashboardfristCardHeading}
                                >
                                  <span className={classes.requiedfield}>
                                    Please review today’s out-of-location punch
                                    in/out.
                                  </span>
                                </Typography>
                              </Grid>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                {outOfLocationIsError ? (
                                  <Box textAlign="center" py={4}>
                                    <Typography color="error">
                                      Error fetching data
                                    </Typography>
                                  </Box>
                                ) : outOfLocationIsLoadig ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    py={4}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : outOfLocationRecords?.length === 0 ? (
                                  <Box textAlign="center" py={4}>
                                    <Typography>No Record Avilable</Typography>
                                  </Box>
                                ) : (
                                  <List sx={{ width: "100%" }}>
                                    {outOfLocationRecords.map((record) => (
                                      <Grid item xs={12} key={record.id}>
                                        <Link
                                          to={`/schedule/list?date=${dayjs(
                                            record.date
                                          ).format("YYYY-MM-DD")}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Card
                                            onClick={() =>
                                              navigate(
                                                `/schedule/list?date=${dayjs(
                                                  record.date
                                                ).format("YYYY-MM-DD")}`
                                              )
                                            }
                                            elevation={0}
                                            sx={{
                                              background:
                                                theme.palette.cardAdd.bgColor,
                                              display: "flex",
                                              alignItems: "center",
                                              p: 1,
                                              py: 1,
                                              cursor: "pointer",
                                              transition: "background 0.2s",
                                              "&:hover": {
                                                backgroundColor:
                                                  theme.palette.action.hover,
                                              },
                                            }}
                                          >
                                            <Badge
                                              color="primary"
                                              sx={{
                                                mr: 2,
                                                "& .MuiBadge-badge": {
                                                  fontSize: "0.75rem",
                                                  minWidth: 20,
                                                  height: 20,
                                                  borderRadius: "50%",
                                                  backgroundColor: "green",
                                                  color: "#fff",
                                                },
                                              }}
                                            >
                                              <Avatar
                                                sx={{
                                                  bgcolor: "primary.main",
                                                }}
                                              >
                                                {teamMap.get(record.empid)
                                                  ?.name ? (
                                                  `${
                                                    teamMap.get(record.empid)
                                                      ?.name
                                                  }`
                                                    .trim()
                                                    .charAt(0)
                                                    .toUpperCase()
                                                ) : (
                                                  <GroupIcon />
                                                )}
                                              </Avatar>
                                            </Badge>

                                            <Box>
                                              <Typography>
                                                {teamMap.get(record.empid)
                                                  ?.name || ""}
                                              </Typography>
                                              <Typography
                                                variant="body2"
                                                sx={{
                                                  fontSize: "0.875rem",
                                                  color: "#444",
                                                }}
                                              >
                                                <strong>
                                                  <span
                                                    style={{
                                                      color: "#e3791a",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    {`${record.status} | `}{" "}
                                                  </span>
                                                </strong>
                                                {`${dayjs(record.date).format(
                                                  "MMM DD, YYYY"
                                                )} | `}
                                                {` ${formatTime(record.time)}`}
                                              </Typography>
                                            </Box>
                                          </Card>
                                        </Link>
                                      </Grid>
                                    ))}
                                  </List>
                                )}
                              </Grid>
                            </>
                          )}
                      </Grid>
                    </Card>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.staffDhashboardSmallCardUpdate}
                    sx={{ minHeight: 200 }}
                  >
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          className={classes.dashboardfristCardHeading}
                        >
                          Today's Attendance
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Timelinechart />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.staffDhashboardSmallCardUpdate}
                    sx={{ minHeight: 200 }}
                  >
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          className={classes.dashboardfristCardHeading}
                        >
                          Payroll Overview
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <PayrollBarChart />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Card
                    className={classes.staffDhashboardSmallCardUpdate}
                    sx={{ minHeight: 200 }}
                  >
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          className={classes.dashboardfristCardHeading}
                        >
                          Payroll
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <PayrollPieChart />
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
